import { SxProps, Theme } from '@mui/material';

export const AccountChangePasswordFormTitleSX: SxProps<Theme> = ({
	fontSize: 'var(--font-size-md)',
	fontWeight: 800,
});

export const AccountChangePasswordFormDescriptionSX: SxProps<Theme> = (theme) => ({
	marginBottom: theme.spacing(1),
});
